import { PropertiesFile } from "../types";
import { SavedRow } from "../types";
export type PropertySource = 'onekey' | 'off-market';
export class PropertyAPI {
  prod_url: URL = new URL('https://event-application.null-988.workers.dev');
  get_by_listing_key_path: string = '/lombardo-property-editor/api/v1/mlscon/get-by-listing-key';
  off_market_path: string = '/lombardo-property-editor/api/v1/published-properties';
  sold_path: string = '/lombardo-property-editor/api/v1/mlscon/sold';
  active_path: string = '/lombardo-property-editor/api/v1/mlscon/active';
  constructor(){
  }
  async get_active_by_source(source: PropertySource) : Promise<PropertiesFile|null> {
    if(source === 'onekey'){
      return await this.get_active_onekey_properties();
    }
    let r: PropertiesFile|null = await this.get_offmarket_properties();
    if(!r){
      return null;
    }
    let filtered: PropertiesFile = {};
    for(const key in r){
      if(['active','pending'].includes(String(r[key].MlsStatus).toLowerCase())){
        filtered[key] = r[key];
      }
    }
    return filtered;
  }
  async get_sold_by_source(source: PropertySource) : Promise<PropertiesFile|null> {
    if(source === 'onekey'){
      return await this.get_sold_onekey_properties();
    }
    let r: PropertiesFile|null = await this.get_offmarket_properties();
    if(!r){
      return null;
    }
    let filtered: PropertiesFile = {};
    for(const key in r){
      if(['sold'].includes(String(r[key].MlsStatus).toLowerCase())){
        filtered[key] = r[key];
      }
    }
    return filtered;
  }
  async get_property_by_source(listing_key: string|number,source: PropertySource) : Promise<SavedRow|null> {
    if(source === 'onekey'){
      return await this.get_onekey_property(String(listing_key));
    }
    return await this.get_offmarket_property(String(listing_key));
  }
  private async get_onekey_property(listing_key: string) : Promise<SavedRow|null> {
    try {
      let url: URL = new URL(this.prod_url);
      url.pathname = this.get_by_listing_key_path;

      let opts: any = {
        headers: {
          'Content-Type': 'application/json',
          'Accept-Encoding': 'gzip',
        },
        method: 'POST',
        body: JSON.stringify({ListingKey: listing_key,}),
      };
      const request: Request = new Request(url, opts);

      return await fetch(request).then(async (response) => {
        return await response.json();
      }).catch((reason) => {
        console.info('get_by_listing_key_path.catch reason:',reason);
        return null;
      });
    }catch(err){
      console.error(`unable to get_sold_onekey_properties because:`,err);
    }
    return null;
  }
  private async get_offmarket_property(listing_key: string) : Promise<SavedRow|null> {
    if(listing_key.match(/^KEY/)){
      listing_key = listing_key.replace(/^KEY/,'');
    }
    try {
      let url: URL = new URL(this.prod_url);
      url.pathname = '/lombardo-property-editor/api/v1/published-property-by-id';
      url.searchParams.set('id',String(listing_key));

      let opts: any = {
        headers: {
          'Content-Type': 'application/json',
          'Accept-Encoding': 'gzip',
        },
        method: 'GET',
      };
      const request: Request = new Request(url, opts);

      return await fetch(request).then(async (response) => {
        return await response.json();
      }).catch((reason) => {
        console.info('get_offmarket_property.catch reason:',reason);
        return null;
      });
    }catch(err){
      console.error(`unable to get_offmarket_property because:`,err);
    }
    return null;
  }
  
  async get_offmarket_properties() : Promise<PropertiesFile|null> {
    try {
      let url: URL = new URL(this.prod_url);
      url.pathname = this.off_market_path;

      let opts: any = {
        headers: {
          'Content-Type': 'application/json',
          'Accept-Encoding': 'gzip',
        },
        method: 'GET',
      };
      const request: Request = new Request(url, opts);

      return await fetch(request).then(async (response) => {
        return await response.json();
      }).catch((reason) => {
        console.info('get_offmarket_properties.catch reason:',reason);
        return null;
      });
    }catch(err){
      console.error(`unable to get_offmarket_properties because:`,err);
    }
    return null;
  }
  async get_sold_onekey_properties() : Promise<PropertiesFile|null> {
    try {
      let url: URL = new URL(this.prod_url);
      url.pathname = this.sold_path;

      let opts: any = {
        headers: {
          'Content-Type': 'application/json',
          'Accept-Encoding': 'gzip',
        },
        method: 'GET',
      };
      const request: Request = new Request(url, opts);

      return await fetch(request).then(async (response) => {
        return await response.json();
      }).catch((reason) => {
        console.info('get_sold_onekey_properties.catch reason:',reason);
        return null;
      });
    }catch(err){
      console.error(`unable to get_sold_onekey_properties because:`,err);
    }
    return null;
  }
  async get_active_onekey_properties() : Promise<PropertiesFile|null> {
    try {
      let url: URL = new URL(this.prod_url);
      url.pathname = this.active_path;

      let opts: any = {
        headers: {
          'Content-Type': 'application/json',
          'Accept-Encoding': 'gzip',
        },
        method: 'GET',
      };
      const request: Request = new Request(url, opts);

      return await fetch(request).then(async (response) => {
        return await response.json();
      }).catch((reason) => {
        console.info('get_active_onekey_properties.catch reason:',reason);
        return null;
      });
    }catch(err){
      console.error(`unable to get_active_onekey_properties because:`,err);
    }
    return null;
  }
}
